<template>
  <div class="dashboard-wrapper">
    <navbar user-type="consumer" />
    <router-view />
    <base-footer />
  </div>
</template>
<script>
import StudentDashboard from "connective/layouts/StudentDashboard"
import BaseFooter from "@/components/BaseFooter"

export default {
  components: { BaseFooter },
  extends: StudentDashboard,
}
</script>
<style scoped>
.dashboard-wrapper {
  margin-bottom: 100px;
}
</style>
